<style scoped lang="scss">
.wrap-compose {
  .c-title1 {
    display: block;
  }
  .cons {
    display: none;
  }
  .banner {
    position: relative;
    .info {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      h1 {
        font-size: 46px;
        color: #fff;
      }
    }
    .classify {
      padding: 20px;
      background: rgba(255, 255, 255, 0.9);
      width: 200px;
      height: 300px;
      position: absolute;
      left: calc((100vw - 1200px) / 2);
      top: 50%;
      transform: translateY(-50%);
      z-index: 9;
      .title {
        padding-bottom: 10px;
        margin-bottom: 20px;
        font-size: 16px;
        font-weight: bold;
        border-bottom: 1px solid #e4e6ea;
      }
      a {
        color: #333;
        &.active {
          color: #014492;
        }
      }
      li {
        margin-bottom: 20px;
      }
    }
  }
  .map {
    width: 980px;
    margin: 0 auto;
    .img-box {
      border: 1px dashed #ccc;
      margin-bottom: 8px;
    }
  }
  .service {
    background: #f6fafd;
    ul {
      display: flex;
      justify-content: space-around;
      padding: 0 10%;
    }
  }
  .mr41 {
    display: block;
  }
  .mr42 {
    display: none;
  }
  .desc-rna {
    width: 1150px;
    margin: 0 auto;
    font-size: 16px;
    color: #333333;
    line-height: 33px;
  }
  .ser-tit {
    font-weight: 600;
    font-size: 32px;
    color: #333333;
    line-height: 45px;
    text-align: center;
    margin: 100px 0 51px;
  }
  .table-box,
  .case-box {
    padding-top: 40px;
    padding-bottom: 20px;
    width: 1150px;
    margin: 0 auto;
  }
  .case-box {
    border: 1px dashed #ccc;
    margin-bottom: 70px;
    img {
      width: 1120px;
    }
  }
}
@media screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width: 400px) {
  .con {
    display: none !important;
  }
  .cons {
    display: block !important;
  }
}
@media screen and (max-width: 640px) {
  .wrap-compose .map {
    width: 90% !important;
    font-size: 14px !important;
  }
  .c-title1 {
    display: none !important;
  }
  .mr42 {
    margin-left: auto;
    margin-right: auto;
    display: block !important;
  }
  .mr41 {
    display: none !important;
  }
  .container {
    width: 90% !important;
    font-size: 14px !important;
  }
  .wrap-compose .banner .info h1 {
    font-size: 25px !important;
  }
}
</style>
<style lang="scss">
.wrap-compose {
  .el-tabs--left .el-tabs__header.is-left {
    margin-right: 0;
  }
  .el-tabs--left .el-tabs__item.is-left {
    height: 200px;
    background: #f6fafd;
    border: 2px solid transparent;
    border-right: 2px solid #e4e6ea;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 210px;
    color: #014492;
    font-size: 20px;
    &.is-active {
      background: #fff;
      border: 2px solid #e4e6ea;
      border-right: 2px solid transparent;
    }
    .label {
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;
    }
  }
  .el-tabs__active-bar {
    display: none;
  }
  .el-tabs__content {
    border: 2px solid #e4e6ea;
    border-left: 0;
    height: 100%;
    padding: 30px;
    overflow-y: auto;
    h5 {
      margin-bottom: 15px;
      font-size: 18px;
    }
    p {
      margin-bottom: 10px;
    }
  }
}
</style>
<template>
  <!--  常规引物合成-->
  <div class="wrap wrap-compose">
    <router-view></router-view>
    <div class="banner">
      <img
        src="@/assets/images/banner_18.png"
        class="img-fluid"
        alt="RNA合成"
      />
      <div class="container info">
        <h1>RNA合成</h1>
        <el-button
          class="mt20 mr42"
          size="mini"
          @click="$router.push('/tec/order_primer')"
          >立即合成</el-button
        >
        <el-button class="mt20 mr41" @click="$router.push('/tec/order_primer')"
          >立即合成</el-button
        >
      </div>
      <div class="classify">
        <div class="title">寡核苷酸合成</div>
        <ul>
          <li><router-link to="/tec/compose1">DNA合成</router-link></li>
          <!-- <li><router-link :to="handleJumpPath('/tec/compose2')">修饰引物/探针合成</router-link></li> -->
          <li>
            <router-link :to="handleJumpPath('/tec/compose3')" class="active"
              >RNA合成</router-link
            >
          </li>
          <!--          <li><router-link to="">探针设计</router-link></li>-->
        </ul>
      </div>
    </div>
    <div
      class="breads container"
      style="
        overflow: auto;
        line-height: 48px;
        padding-left: 10px;
        margin-bottom: 20px;
      "
    >
      <bread></bread>
    </div>
    <div class="c-title">RNA合成介绍</div>
    <div class="map">
      <div class="img-box">
        <img
          src="@/assets/images/compose_3_1.png"
          class="img-fluid con"
          alt="擎科生物-RNA合成服务"
        />
        <img
          src="@/assets/images/compose_3_2.png"
          class="img-fluid cons"
          alt="擎科生物-RNA合成服务"
        />
      </div>
    </div>
    <p class="desc-rna">
      RNA干扰（RNA
      interfering，RNAi）现象是由与靶基因序列同源的双链RNA（double-stranded
      RNA，dsRNA）引发的广泛存在于生物体内的序列特异性基因转录后的沉默过程。细胞中的核糖核酸酶III家族成员之一的，dsRNA特异性的核酸酶Dicer将dsRNA裂解成由21-25个核苷酸组成的小干扰RNA
      (small interfering
      RNA，siRNA)，随后siRNA作为介导子引起特异性地降解相同序列的mRNA，从而阻断相应基因表达的转录后基因沉默机制。
    </p>
    <h2 class="ser-tit">服务详情</h2>
    <p class="desc-rna">
      擎科生物具有完整的RNA合成平台，可为客户提供μg~kg级的RNA合成服务，包括siRNA miRNA ASO sgRNA等多种修饰RNA，并且严格执行ISO 13485标准，每条RNA都经过质谱检测，其中siRNA合成速度快至3个工作日，加快RNAi研究进度。
    </p>
    <div class="table-box">
      <el-table
        :data="tableData"
        border
        header-cell-style="background-color:#F4FAFF; color:#333"
        :span-method="arraySpanMethod"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column
          prop="productName"
          label="产品名称"
          header-align="center"
          align="center"
          width="115"
        >
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          header-align="center"
          align="center"
          width="225"
        >
        </el-table-column>
        <el-table-column
          prop="specifications"
          label="规格"
          header-align="center"
          align="center"
          width="165"
        >
        </el-table-column>
        <el-table-column
          prop="purificationMethod"
          label="纯度级别"
          header-align="center"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="productionCycle"
          label="生产周期（工作日）"
          header-align="center"
          align="center"
          width="175"
        >
        </el-table-column>
        <el-table-column
          prop="explain"
          label="说明"
          header-align="center"
          align="left"
          width="349"
        >
        </el-table-column>
      </el-table>
    </div>
    <p class="desc-rna">
      说明：除了推荐的内容之外，我们还提供定制化的合成服务。如果您需要了解更多的合成类型和产品价格信息，请与我们联系。
    </p>
    <h2 class="ser-tit">案例</h2>
    <div class="desc-rna">siRNA质谱合格，客户端应用实现良好的干扰效果。</div>
    <div class="case-box">
      <img src="@/assets/images/case.png" />
    </div>
    <!-- 订购与咨询 -->
    <div class="container">
      <new-consult
        type="rna"
        title=""
        enTitle=""
        phoneNumber="400-668-3730 转4"
        :typeList="['telePhone', 'download', 'email']"
      ></new-consult>
    </div>
    <!-- <qk-consult type="rna" /> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import bread from "@/components/bread";
export default {
  components: {
    bread,
  },
  data() {
    return {
      tableData: [
        {
          productName: "sgRNA",
          type: "sgRNA",
          specifications: "1.5 nmol",
          purificationMethod: "OPC",
          productionCycle: "7",
          explain: "3’端和5’端各3个硫代和甲氧基修饰，更稳定",
        },
        {
          productName: "sgRNA",
          type: "sgRNA",
          specifications: "1.5 nmol",
          purificationMethod: "HPLC",
          productionCycle: "12~15",
          explain: "3’端和5’端各3个硫代和甲氧基修饰，更稳定",
        },
        {
          productName: "crRNA",
          type: "crRNA",
          specifications: "5 nmol/2 OD",
          purificationMethod: "HPLC",
          productionCycle: "12~15",
          explain: "3’端和5’端各3个硫代和甲氧基修饰，更稳定",
        },
        {
          productName: "siRNA",
          type: "1条siRNA",
          specifications: "5 nmol/2 OD",
          purificationMethod: "HPLC",
          productionCycle: "3～4",
          explain:
            "常规siRNA为常规化学合成的即用型双链RNA，配置成工作浓度液体，即可直接用于转染细胞",
        },
        {
          productName: "siRNA",
          type: "siRNA NC",
          specifications: "2.5 nmol/1 OD",
          purificationMethod: "HPLC",
          productionCycle: "现货",
          explain: "可选阴性对照siRNA、阳性对照siRNA、转染对照siRNA等多种类型",
        },
        {
          productName: "siRNA",
          type: "siRNA 三保一",
          specifications: "5 nmol/2 OD",
          purificationMethod: "HPLC",
          productionCycle: "3～4",
          explain:
            "在转染效率达到80%的前提下，三条siRNA中至少一条mRNA干扰效率>70%",
        },
        {
          productName: "siRNA",
          type: "siRNA 四保一",
          specifications: "5 nmol/2 OD",
          purificationMethod: "HPLC",
          productionCycle: "3～4",
          explain:
            "在转染效率达到80%的前提下，四条siRNA中至少一条mRNA干扰效率>70%",
        },
        {
          productName: "miRNA",
          type: "miRNA mimics",
          specifications: "5 nmol/2 OD",
          purificationMethod: "HPLC",
          productionCycle: "3～4",
          explain: "用于干扰miRNA（microRNA）相关实验",
        },
        {
          productName: "miRNA",
          type: "miRNA inhibitor",
          specifications: "10 nmol/2 OD",
          purificationMethod: "HPLC",
          productionCycle: "3～4",
          explain: "用于干扰miRNA（microRNA）相关实验",
        },
        {
          productName: "miRNA",
          type: "mimics/inhibitor(NC)",
          specifications: "1 OD",
          purificationMethod: "HPLC",
          productionCycle: "现货",
          explain: "用于干扰miRNA（microRNA）相关实验",
        },
        {
          productName: "miRNA",
          type: "miRNA agomir",
          specifications: "2 OD",
          purificationMethod: "HPLC",
          productionCycle: "5～7",
          explain:
            "具有特殊化学修饰的激动剂/拮抗剂，可用于体内实验，用于干扰miRNA（microRNA）相关实验",
        },
        {
          productName: "miRNA",
          type: "miRNA antagomir",
          specifications: "2 OD",
          purificationMethod: "HPLC",
          productionCycle: "5～7",
          explain:
            "具有特殊化学修饰的激动剂/拮抗剂，可用于体内实验，用于干扰miRNA（microRNA）相关实验",
        },
        {
          productName: "miRNA",
          type: "agomir/antagomir(NC)",
          specifications: "2 OD",
          purificationMethod: "HPLC",
          productionCycle: "5～7",
          explain:
            "具有特殊化学修饰的激动剂/拮抗剂，可用于体内实验，用于干扰miRNA（microRNA）相关实验",
        },
        {
          productName: "ASO",
          type: "PS-ASO",
          specifications: "2 OD",
          purificationMethod: "HPLC",
          productionCycle: "3～4",
          explain: "用于干扰核内lncRNA和环状RNA，多种修饰类型可选",
        },
        {
          productName: "ASO",
          type: "LNA-ASO",
          specifications: "2 OD",
          purificationMethod: "HPLC",
          productionCycle: "3～4",
          explain: "用于干扰核内lncRNA和环状RNA，多种修饰类型可选",
        },
        {
          productName: "ASO",
          type: "OMe-ASO",
          specifications: "2 OD",
          purificationMethod: "HPLC",
          productionCycle: "3～4",
          explain: "用于干扰核内lncRNA和环状RNA，多种修饰类型可选",
        },
      ],
    };
  },
  computed: {
    ...mapState(["pageData"]),
  },
  methods: {
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if ([0, 1, 5].includes(columnIndex)) {
        if (rowIndex == 0) {
          return [2, 1];
        } else if (rowIndex == 1) {
          return [0, 0];
        }
      }
      if ([0].includes(columnIndex)) {
        if (rowIndex === 3) {
          return [4, 1];
        } else if (rowIndex > 3 && rowIndex < 7) {
          return [0, 0];
        }
        if (rowIndex === 7) {
          return [6, 1];
        } else if (rowIndex > 7 && rowIndex < 13) {
          return [0, 0];
        }
        if (rowIndex === 13) {
          return [3, 1];
        } else if (rowIndex > 13 && rowIndex < 16) {
          return [0, 0];
        }
      }
      if ([5].includes(columnIndex)) {
        if (rowIndex === 7 || rowIndex === 10 || rowIndex === 13) {
          return [3, 1];
        } else if (
          (rowIndex > 7 && rowIndex < 10) ||
          (rowIndex > 10 && rowIndex < 13) ||
          (rowIndex > 13 && rowIndex < 16)
        ) {
          return [0, 0];
        }
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      return "color:#333 ";
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    objectSpanMethod0({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 1,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 1,
            colspan: 1,
          };
        }
      }
    },
    objectSpanMethod2({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 3) {
        if (rowIndex === 0 || rowIndex === 4) {
          return {
            rowspan: 4,
            colspan: 1,
          };
        } else if (rowIndex === 8) {
          return {
            rowspan: 3,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    objectSpanMethod3({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: 7,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    objectSpanMethod4({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: 10,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    handleJumpPath(path) {
      let queryPath = "";
      if (this.$route.path === "/tec/compose1") {
        queryPath = "product=true";
      }
      Object.entries(this.$route.query).forEach(([key, value = ""]) => {
        queryPath += `${key}=${value}`;
      });
      return `${path}?${queryPath}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/tec/compose_3.vue